import { SegmentImage } from "./PatientConsentManagerShared.styles";
import { withLoadTracking } from "./withLoadTracking";
export const ImageWithLoadTracking = withLoadTracking(SegmentImage);
ImageWithLoadTracking.displayName = "ImageWithLoadTracking";
